import { mergeSkipNullish } from "components/helpers";
import { TABLE_PAGE_CONTAINER_HEIGHT } from "constants/Constants";

const defaultStyles = {
  display: "flex",
  height: TABLE_PAGE_CONTAINER_HEIGHT.ONLY_HEADER,
  width: "100%",
  flexDirection: "column",
  overflowY: "auto",
  padding: "1.5em",
};

// Under SidebarDetailLayout the rail carries the section menu, so a table
// section fills the whole content column.
export const SECTION_TABLE_STYLES = { height: "100%", padding: 0 };

export default function PageContainer({ children, styles = {} }) {
  return (
    <div style={mergeSkipNullish({ target: defaultStyles, source: styles })}>
      {children}
    </div>
  );
}
